<div class="ets1-reminder-notes-config">
	<div class="mb-4 flex items-center justify-between gap-4">
		<p class="text-sm text-grey-80">{{ noteCount }} of {{ maxNotes }} Additional Training/Assessment Details</p>
		@if (!readOnly) {
			<button type="button" class="aa-btn" data-variant="secondary" [disabled]="!canAdd" (click)="onAdd()">
				+ Add
			</button>
		}
	</div>

	<div class="flex flex-col gap-4">
		@for (note of reminderNotes.controls; track $index; let i = $index) {
			<div class="rounded border border-grey-20 p-4" [formGroup]="$any(note)">
				<div class="mb-2 flex items-center justify-between gap-2">
					<span class="font-medium">Additional Training/Assessment Details {{ i + 1 }}</span>
					@if (!readOnly) {
						<button type="button" class="text-sm text-red underline" (click)="onRemove(i)">Remove</button>
					}
				</div>
				<mat-form-field appearance="outline" class="w-full">
					<textarea
						matInput
						formControlName="text"
						rows="4"
						[maxlength]="maxLength"
						placeholder="Enter reminder note text"
						[readonly]="readOnly"
					></textarea>
				</mat-form-field>
				<mat-slide-toggle formControlName="requireStatus" color="primary">
					Require status selection (Satisfactory / Unsatisfactory / N/A)
				</mat-slide-toggle>
			</div>
		}
	</div>
</div>
